import { TextAlignLeftIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const AlignLeft = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <TextAlignLeftIcon size={Sizes[size]} {...rest} color={fill} />;
};

AlignLeft.displayName = 'AlignLeft';
